/* eslint-disable no-console */
// TODO: Add support for an error/warning code for association to docs - @ixTec
export var WAFFLES_ERROR_PREFIX = 'WAFFLES Error: ';
export var WAFFLES_WARN_PREFIX = 'WAFFLES Warning: ';
/**
 * Log a `console.error` from within a Waffles component.
 *
 * @param message The message to provide alongside the error
 */
export function logError(message) {
    console.error(WAFFLES_ERROR_PREFIX.concat(message));
}
/**
 * Log a `console.warn` from within a Waffles component.
 *
 * @param message The message to provide alongside the warning
 */
export function logWarning(message) {
    console.warn(WAFFLES_WARN_PREFIX.concat(message));
}
